/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React, { Fragment } from 'react';
import { useStaticQuery, graphql } from 'gatsby';

import '../assets/fonts/inter.css';

import Header from './Header';
import Footer from './Footer';
import CompactFooter from './CompactFooter';
import { TailwindBreakpointIndicator } from './shared/TailwindBreakpointIndicator';

interface Props {
  isIndexPage?: boolean;
  currentPath?: string;
}

const Layout: React.FC<Props> = ({
  children,
  currentPath,
  isIndexPage = false,
}) => {
  const { sanityHomePage } = useStaticQuery(graphql`
    query HomePageQuery {
      sanityHomePage {
        title
        address {
          line1
          line2
        }
        email
        phoneNumber
      }
    }
  `);

  return (
    <Fragment>
      <a
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded-md focus:bg-white focus:px-4 focus:py-2 focus:font-medium focus:text-blue-700 focus:shadow-lg"
        href="#glavni-sadrzaj"
      >
        Preskoči na sadržaj
      </a>

      <Header
        currentPath={currentPath}
        light={!isIndexPage}
        siteTitle={sanityHomePage.title}
      />

      <main className="antialiased" id="glavni-sadrzaj">
        {children}
      </main>

      {isIndexPage ? (
        <Footer title={sanityHomePage.title} />
      ) : (
        <CompactFooter
          address={sanityHomePage.address}
          email={sanityHomePage.email}
          phoneNumber={sanityHomePage.phoneNumber}
          title={sanityHomePage.title}
        />
      )}

      <TailwindBreakpointIndicator />
    </Fragment>
  );
};

export default Layout;
